<template>
    <div id="spik" class="cardlist container block-uch">
        <h2>{{uchastniki.title}}</h2>
        <div v-for="(item, index) in uchastniki.list" :key="index"
            class="card">
            <div class="row">
                <div class="col __m">
                    <div class="title">{{ item.name.raw }}</div>
                    <div class="description">{{ item.description }}</div>
                </div>
                <div class="col photo">
                    <div class="img"><img :src="item.img.src" loading="lazy"></div>
                </div>
                <div class="col flex-grow-1">
                    <div class="__d">
                        <div class="title">{{ item.name.raw }}</div>
                        <div class="description">{{ item.description }}</div>
                    </div>
                    <div class="__aa-wrap">
                        <template v-if="item.about.list.length">
                            <div class="about-wrap">
                                <div class="about">
                                    <div class="title">О спикере</div>
                                    <ul>
                                        <li v-for="(item2, index2) in item.about.list" :key="index2">{{ item2 }}</li>
                                    </ul>
                                </div>
                                <div class="__btn-wrap">
                                    <button
                                        @click="() => { handleClickButtonDetail(item, 'about') }"
                                    >&middot;&middot;&middot;</button>
                                </div>
                            </div>
                        </template>
                        <div class="agenda-wrap">
                            <div class="agenda">
                                <div class="title">Тема выступления</div>
                                <template v-for="(item3, index3) in item.agenda" :key="index3">
                                    <div v-if="item3.title">{{ item3.title }}</div>
                                    <ul>
                                        <li class="plus" v-for="(item4, index4) in item3.list" :key="index4">{{ item4 }}</li>
                                    </ul>
                                </template>
                            </div>
                            <div class="__btn-wrap">
                                <button
                                    @click="() => { handleClickButtonDetail(item, 'agenda') }"
                                >&middot;&middot;&middot;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="__com-wrap">
                <button class="__com"
                    @click="() => { handleClickButtonDetail(item, 'common') }"
                >подробнее</button>
            </div>
        </div>
    </div>
    <Transition>
        <PopupBlock 
            v-if="popupIsVisible"
            @event-close-popup="handleEventClosePopup"
        >
            <UchastnikCard :item="popupItem"></UchastnikCard>
        </PopupBlock>
    </Transition>
</template>
<script>
import uchastniki from '@/lib/uchastniki'
import PopupBlock from '@/components/PopupBlock'
import UchastnikCard from '@/components/UchastnikCard';

export default {
    name: 'UchastnikBlock',
    components: { 
        PopupBlock,
        UchastnikCard
    },
    props: {},
    data() {
        return {
            uchastniki: uchastniki,
            popupIsVisible: false,
            popupItem: {},
        }
    },
    // emits: [ ],
    // mounted() {
    // },
    methods: {
        handleClickButtonDetail: function(item, moveTo) {
            this.popupIsVisible = true
            this.popupItem = item
            document.body.style.overflow = 'hidden'
            moveTo
            // console.log('click', item, moveTo )
            
        },
        handleEventClosePopup: function() {
            // console.log('event close')
            this.popupIsVisible = false
            this.popupItem = {}
            document.body.style.overflow = 'auto'
            
        },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
.row{
    display: flex;
    flex-wrap: wrap;
    // justify-content: flex-start;
    // .__m{
    //     display: none;
    // }
    // .__d{
    //     display: block;
    // }
    // @media ( min-width: 992px ) {
    //     .__m{
    //         display: block;
    //     }
    //     .__d{
    //         display: none;
    //     }
    // }

    .col{
        display: flex;
        flex-direction: column;
        width: 100%;
        // &.photo{
        //     // flex-basis: 33%;
        //     // justify-content: flex-end;
        // }
    }
    @media ( min-width: 992px ) {
        .col{
            width: 50%;
            &.photo{
                flex-basis: 33%;
                // flex-grow: 1;
                // justify-content: flex-end;
                .img{
                    margin-top: .5em;
                }
            }
        }
    }
    .flex-grow-1{
        flex-grow: 1;
    }
}
.block-uch{
    .card{
        // max-height: 410px;
        @media (max-width: 992px) {
            .__com-wrap{
                text-align: right;
                button.__com{
                    // justify-self: flex-end;
                    // text-align: right;
                    // align-self: flex-end;
                    margin: 10px 0px 0px 0px;
                    position: static;
                    // top: 0;
                    // right: 0;
                }
            }
        }
        overflow: hidden;
        .img{
            max-width: 300px;
        }
        @media (min-width: 576px) {
        }
    
        @media (min-width: 768px) {
        }
        @media (min-width: 992px) {
            max-height: 410px;
            .img{
                max-width: none
            }
        }
    
        @media (min-width: 1200px) {
            max-height: 484px;
        }
    
        @media (min-width: 1400px) {
            max-height: 568px;
        }     
        // .__aa-wrap{
        //     display: flex;
        //     flex-direction: column;
            
        //     // overflow: hidden;
        //     // max-height: fit-content;
        // }
        .about{
            max-height: 135px;
            // overflow: scroll;
            overflow: hidden;
        }
        .agenda{
            max-height: 135px;
            overflow: hidden;
            // overflow: scroll;
        }
        &:nth-child(2){ // отсчёт ВНЕЗАПНО от 2
            
            @media ( min-width: 992px ) {
                .about{
                    max-height: 125px;
                }
                .agenda{
                    max-height: 150px;
                }
                // .agenda-wrap{
                //     // .__btn-wrap{
                //     //     display: none;
                //     // }    
                // }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 200px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 282px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
        }
        &:nth-child(3){ // отсчёт ВНЕЗАПНО от 2
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 136px;
                    }
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 150px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 232px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 288px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
        }
        &:nth-child(4){ // отсчёт ВНЕЗАПНО от 2
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 136px;
                    }
                    .__btn-wrap{
                        display: none;
                    }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 150px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 232px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 300px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
            }
        }
        &:nth-child(5){ // отсчёт ВНЕЗАПНО от 2
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 136px;
                    }
                    .__btn-wrap{
                        display: none;
                    }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 188px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 266px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 300px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
            }
        }
        &:nth-child(6){ // отсчёт ВНЕЗАПНО от 2
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 124px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 160px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 120px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 235px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 185px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 300px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
            }
        }
        &:nth-child(7){ // gladchenko 
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 124px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 168px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: 120px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 235px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 185px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height:262px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
        }
        &:nth-child(8){ // birukova 
            
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 130px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: none;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 160px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 185px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height:262px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
        }
        &:nth-child(9){ // fyodorova
            // .photo{
            //     .img{
            //         height: 100%;
            //         width: 100%;
            //         object-fit: contain;
            //         img{
            //             width: 100%;
            //             height: auto;
            //         }
            //     }
            // }
            @media ( min-width: 992px ) {
                .about-wrap{
                    .about{
                        max-height: 135px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }  
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 130px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1200px ) {
                .about-wrap{
                    .about{
                        max-height: none;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height: 160px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
            @media ( min-width: 1400px ) {
                .about-wrap{
                    .about{
                        max-height: 185px;
                    }
                    .__btn-wrap{
                        display: none;
                    }    
                }
                .agenda-wrap{
                    .agenda{
                        max-height:262px;
                    }
                    // .__btn-wrap{
                    //     display: none;
                    // }    
                }
            }
        }

        // &:nth-child(4){
        //     .about-wrap{
        //         .__btn-wrap{
        //             display: none;
        //         }    
        //     }
        // }
        // &:nth-child(5){
        //     .__btn-wrap{
        //         // display: none;
        //     }
        // }
        // .__aa-wrap{
        //     display: flex;
        //     flex-direction: column;
        //     .about-wrap{

        //     }
        //     .agenda-wrap{
        //         flex-grow: 1;
        //     }
        // }
        // @media ( min-width: 992px ) {

        //     height: 405px;
        //     overflow: hidden;
        // }
    }
}
.card{
    // background: #243255;
    position: relative;
    color: #fff;
    // border: solid 1px #fff;
    background-color: #45289C;
    // background: rgba(255, 255, 255, .80);
    // color: #000;
    background-image: radial-gradient( circle at 8% 35%, #1E9BD8 -20%, transparent 26% ), radial-gradient( circle at 105% 43%, #290A4F -10%, transparent 23%);
    @media ( min-width: 992px ) {
        background-image: radial-gradient( circle at 8% 74%, #1E9BD8 -20%, transparent 26% ), radial-gradient( circle at 105% 43%, #290A4F -10%, transparent 23%);
    }
    // background-image: radial-gradient( circle at 75% 75%, #4364b6, transparent );
    // ul,ol{
    //     li{
    //         color: #fff;
    //         margin-bottom: .75em;
    //     }
    // }
    border-radius: 22px;
    padding: 1em 1em 1em 1em;
    margin-bottom: 1em;
    text-align: left;
    
    .__m{
        display: block;
    }
    .__d{
        display: none;
    }
    @media ( min-width: 992px ) {
        padding: 1em 1em 0em 0;
        .__m{
            display: none;
        }
        .__d{
            display: block;
        }
    }

    .title{
        font-size: 1.5em;
        // text-align: center;
        // margin-bottom: .85em;
        color: #FFF;
        text-transform: uppercase;
        
    }
    .img{
        // max-width: 250px;
        border-radius: 15px;
        // border-bottom: solid 1px #fff;
        // background-image: linear-gradient( transparent, $primary, transparent );
        overflow: hidden;
        align-self: center;
        // padding-right: 16px;
        img{
            width: 100%;
            height: auto;
        }

    }
    .description{
        margin-bottom: .85em;
        // font-style: italic;
        padding: .25em 0 0 0;
        // text-align: center;
        // border-top: solid 1px #ffffff25;
        color: #1E9BD8;
        text-transform: uppercase;
        @media ( min-width: 992px ) {
            text-align: left;
        }
    }
    .list{
        ul{
            list-style: none;
        }
    }
    .about-wrap{
        position: relative;
        border: solid 1px #1E9BD8;
        padding: 16px;
        border-radius: 10px;
        margin-bottom: 1em;
        &::before{
            content: '“';
            color: #1E9BD8;
            font-size: 80px;
            position: absolute;
            top: -25px;
            right: 19px;
            display: block;
            height: 0px;
            width: 0px;
        }
    }
    .agenda-wrap{
        position: relative;
        .__btn-wrap{
            // background-image: radial-gradient( circle at 50% 300%, #1E9BD8 0%, transparent 30% ), linear-gradient( 0deg, #1E9BD8 0%, transparent 60% );    
            // background-image: linear-gradient( 90deg, transparent 0%, #1E9BD8 50%, transparent 100% ), radial-gradient( circle at 50% 300%, #1E9BD8 0%, transparent 30% );
            border: none;
            height: 4px;
        }
    }
    .__btn-wrap{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        // border-radius: 10px;
        // border-bottom: solid 1px #3fc7dc;

        background-image: linear-gradient( 90deg, transparent 25%, #1E9BD8 50%, transparent 75% ), radial-gradient( circle at 50% 300%, #1E9BD8 0%, transparent 30% );
        border: none;
        height: 4px;
        // outline-color: #1E9BD8;
        // background-image: radial-gradient( circle at 50% 35%, #1E9BD8 -20%, transparent 26% );
        // background-image: radial-gradient( circle at 50% 300%, #1E9BD8 0%, transparent 30% ), linear-gradient( 0deg, #1E9BD8 0%, transparent 60% );
        // background-image: linear-gradient( #1E9BD8 -20%, transparent 26% );
        display: flex;
        justify-content: center;
        align-items: center;
        button{
            position: relative;
            top: 1px;
            left: 0;
            // background: #1E9BD8;
            background: #1e9ad8;
            border: none;
            border-radius: 50px;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 1em;
            color: #fff;
            padding: 0px 16px;
            box-shadow: 0px 0px 6px 4px #1E9BD8;
        }
    }
    button.__com{
        position: absolute;
        right: 15px;
        bottom: 15px;
        background: #1E9BD8;
        color: #FFF;
        border-radius: 50px;
        border: solid 1px #1E9BD8;
        padding: 10px 24px;
        font-size: .9em;
        text-transform: capitalize;

    }
    // .about{
        
    // }
    .about,.agenda{
        // padding-left: 1em;
        ul{
            padding-left: 1.5em;
        }
        .title{
            color: #ffffff;
            // color: #1E9BD8;
            font-size: 1.25em;
            text-align: left;
        }
    }
    @media ( min-width: 992px ) {
        .title{
            text-align: left;
        }
    }
}
</style>